<template>
  <div>
    <!-- daterange 类型（最常用） -->
    <el-date-picker
      v-if="type === 'daterange'"
      v-model="localValue"
      type="daterange"
      clearable
      :range-separator="$t('placeHolder.to')"
      :start-placeholder="placeholderspan + $t('placeHolder.start')"
      :end-placeholder="placeholderspan + $t('placeHolder.end')"
      size="mini"
      @change="handleDateChange"
      @clear="handleClear"
      style="height: 100%;"
    />
    <!-- 普通 date 类型 -->
    <el-date-picker
      v-else-if="type === 'date'"
      v-model="localValue"
      type="datetime"
      clearable
      :placeholder="placeholderspan"
      size="mini"
      @change="handleDateChange"
      @clear="handleClear"
      style="height: 100%;"
    />

    <!-- 其他类型（datetime、month 等） -->
    <el-date-picker
      v-else
      v-model="localValue"
      :type="type"
      clearable
      :placeholder="placeholderspan"
      size="mini"
      @change="handleDateChange"
      @clear="handleClear"
      style="height: 100%;"
    />
  </div>
</template>

<script>
import { switchTime } from "@/utils/methods";

export default {
  name: "Y-date",
  props: {
    placeholder: String,
    type: {
      type: String,
      default: "daterange",
    },
    value: {
      type: [String, Array, Date, Object],
      default: () => '',
    },
  },
  data() {
    return {
      placeholderspan: "",
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(newVal) {
        // 这里可以暂时不做处理，交给 @change 统一处理
        this.$emit("update:value", newVal);
      },
    },
  },
  created() {
    this.placeholderspan = this.placeholder || this.$t("homeSet.inputPlaceHolder");
  },

  methods: {
    // 统一处理选择日期后的格式转换
    handleDateChange(val) {
      if (this.type === "daterange") {
        if (val && val.length === 2) {
          const [start, end] = val;
          const _minDate = switchTime(new Date(start).getTime());
          const _maxDate = switchTime(new Date(end).getTime());
          this.$emit("update:value", [_minDate, _maxDate]);
        } else {
          this.$emit("update:value", []);
        }
      } else {
        // 其他类型（date、datetime 等）直接透传或按需转换
        this.$emit("update:value", val ? switchTime(new Date(val).getTime()) : '');
      }
    },

    // 清空时强制发出空数组（daterange）或 null
    handleClear() {
      if (this.type === "daterange") {
        this.$emit("update:value", []);
      } else {
        this.$emit("update:value", '');
      }
    },
  },

  mounted() {
    this.$emit("mounted");
  },
};
</script>

<style scoped lang='scss'>
/deep/.el-range-separator {
  display: flex;
  align-items: center;
}
</style>